import './stock/wow.js';
import './stock/appear.js';
import './stock/jquery.fancybox.js';
import './stock/owl.js';
import 'parallax-js';
import './stock/script.js';
import './stock/validation.js';

